import { ChangeDetectionStrategy, Component, computed, input, output, viewChildren } from '@angular/core';

import { AppleApplication } from '@rocksoft/mdm-sdk-v2';
import { AppleApplicationListItemComponent } from './apple-application-list-item.component';

@Component({
  selector: 'ml-mdm-apple-application-list-ui',
  templateUrl: './apple-application-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppleApplicationListItemComponent],
})
export class AppleApplicationListComponent {
  readonly components = viewChildren<AppleApplicationListItemComponent>('item');
  readonly applications = input<AppleApplication[][]>([]);
  readonly hideVersionSelector = input(false);
  readonly selectedApplicationChange = output<AppleApplication>();

  public selectedIndex: number;

  private selectedApplication: AppleApplication;

  readonly sortedApplications = computed<AppleApplication[][]>(() => {
    const applications = this.applications();
    if (!applications || applications.length === 0) return [];
    return [...applications].sort((a, b) => {
      if (a.length === 0 || b.length === 0) {
        return 0;
      }

      return a[0]?.displayName?.localeCompare(b[0]?.displayName ?? '') ?? 0;
    });
  });

  public select(index: number) {
    this.selectedIndex = index;
    const selectedApplication = this.components()[this.selectedIndex].selectedApplication;
    if (selectedApplication) {
      this.selectApplication(selectedApplication);
    }
  }

  public itemSelectionChanged(index: number, selectedApplication: AppleApplication) {
    // Ignore child selection if it is not the selected item in the list
    if (this.selectedIndex !== index) {
      return;
    }

    this.selectApplication(selectedApplication);
  }

  private selectApplication(selectedApplication: AppleApplication) {
    if (this.selectedApplication !== selectedApplication) {
      this.selectedApplication = selectedApplication;
      this.selectedApplicationChange.emit(this.selectedApplication);
    }
  }
}
